import React from 'react';
export function EmotionSection() {
  const benefits = [{
    title: 'Sun damage, erased.',
    description: 'Brown spots, redness, discoloration faded permanently.'
  }, {
    title: 'Tone that looks effortless.',
    description: "Like a filter — except it's actually your skin."
  }, {
    title: 'Younger at the cellular level.',
    description: 'BBL is the only light treatment proven to reverse aging markers in DNA. (Stanford University research)'
  }];
  return <section className="py-20 md:py-32 bg-brand-bg" data-id="element-81">
      <div className="container px-4 md:px-6" data-id="element-82">
        <div className="text-center max-w-3xl mx-auto mb-16 md:mb-24" data-id="element-83">
          <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl text-brand-text" data-id="element-84">
            Even. Bright. Undeniably you.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-85">
          {benefits.map((benefit, index) => <div key={index} className="bg-brand-alt p-8 md:p-10 rounded-sm border border-brand-divider/50 hover:border-brand-gold/30 transition-colors duration-500 flex flex-col h-full" data-id="element-86">
              <div className="text-brand-gold mb-6 text-2xl" data-id="element-87">✦</div>
              <h3 className="font-playfair text-xl md:text-2xl text-brand-text mb-4" data-id="element-88">
                {benefit.title}
              </h3>
              <p className="font-sans text-brand-text/70 leading-relaxed mt-auto" data-id="element-89">
                {benefit.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}